function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import App from 'modules/App';
import { getRedirectUrl } from 'helpers/integration';
import BackButton from '../BackButton';
var _React_Component;
class BackToIntegrationApp extends (_React_Component = React.Component) {
    render() {
        if (!this.props.to || !this.props.allowReturnToPartner) return null;
        const backToIntegrationAppProps = {
            to: getRedirectUrl(this.props.to)
        };
        return /*#__PURE__*/ _jsx(BackButton, _object_spread({}, backToIntegrationAppProps));
    }
}
_define_property(BackToIntegrationApp, "propTypes", {
    to: PropTypes.string,
    onClick: PropTypes.func,
    // Explicit props
    allowReturnToPartner: PropTypes.bool
});
const mapStateToProps = ()=>(state)=>({
            allowReturnToPartner: App.selectors.allowReturnToPartner(state)
        });
const mapDispatchToProps = ()=>({});
const ConnectedBackToIntegrationApp = connect(mapStateToProps, mapDispatchToProps)(BackToIntegrationApp);
export default ConnectedBackToIntegrationApp;
